// extracted by mini-css-extract-plugin
module.exports = {"Layout":"layout_Layout__2Gb5D"};